var map = {
	"./cs/core": [
		1766,
		766
	],
	"./da/core": [
		3453,
		453
	],
	"./de/core": [
		8417,
		417
	],
	"./en/core": [
		7709
	],
	"./es/core": [
		3552,
		552
	],
	"./fr/core": [
		5276,
		276
	],
	"./it/core": [
		4319,
		319
	],
	"./ja/core": [
		6679,
		679
	],
	"./ko/core": [
		4274,
		274
	],
	"./pl/core": [
		8100,
		100
	],
	"./pt-BR/core": [
		3051,
		51
	],
	"./ru/core": [
		8635,
		635
	],
	"./sk/core": [
		4062,
		62
	],
	"./sv/core": [
		6939,
		939
	],
	"./uz/core": [
		2414,
		33
	],
	"./zh/core": [
		6710,
		710
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;